/* eslint-disable import/no-named-as-default */
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import trikesSlice from "./Slices/trikes.slice";
import batteriesSlice from "./Slices/batteries.slice";
import loggedInUserSlice from "./Slices/loggedInUser.slice";
import usersSlice from "./Slices/users.slice";
import servicesSlice from "./Slices/services.slice";
import locationSlice from "./Slices/locations.slice";
import tripsSlice from "./Slices/trips.slice";
import inventorySlice from "./Slices/inventory.slice";
import homeSlice from "./Slices/home.slice";
import qrcodeSlice from "./Slices/qrcode.slice";
import tenantsSlice from "./Slices/tenants.slice";
import chargersSlice from "./Slices/chargers.slice";
import revenueSlice from "./Slices/revenue.slice";
import ratesSlice from "./Slices/rates.slice";
import powerAfricaSlice from "./Slices/powerAfrica.slice";
import sessionsSlice from "./Slices/sessions.slice";
import requestsSlice from "./Slices/requests.slice";
import hubsSlice from "./Slices/hubs.slice";
import rentalsSlice from "./Slices/rentals.slice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "loggedInUser",
    "trikes",
    "batteries",
    "users",
    "services",
    "locations",
    "trips",
    "qrCode",
    "tenants",
    "chargers",
    "revenue",
    "rates",
    "powerAfrica",
    "sessions",
    "requests",
    "hubs",
    "rentals",
  ],
};

const reducer = combineReducers({
  loggedInUser: loggedInUserSlice,
  trikes: trikesSlice,
  batteries: batteriesSlice,
  users: usersSlice,
  services: servicesSlice,
  locations: locationSlice,
  trips: tripsSlice,
  inventory: inventorySlice,
  home: homeSlice,
  qrCode: qrcodeSlice,
  tenants: tenantsSlice,
  chargers: chargersSlice,
  revenue: revenueSlice,
  rates: ratesSlice,
  powerAfrica: powerAfricaSlice,
  sessions: sessionsSlice,
  requests: requestsSlice,
  hubs: hubsSlice,
  rentals: rentalsSlice,
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
});

export const persistor = persistStore(store);
